import { setLayoutPreference } from "../hooks/useLayoutMode";
import type { TopicId } from "../types/dashboard";
import { topicById } from "../registry/topics";
import { MobileFreqStrip } from "./MobileFreqStrip";

export function MobileHeader({ topicId }: { topicId: TopicId }) {
  const topic = topicById(topicId);

  return (
    <header className="mobile-shell__header">
      <div className="flex items-start justify-between gap-3">
        <div>
          <h1
            className="font-semibold text-text-primary"
            style={{ fontSize: "var(--font-display)" }}
          >
            {topic.title ?? topic.label}
          </h1>
        </div>
        <button
          type="button"
          className="mobile-shell__desktop-link shrink-0"
          onClick={() => setLayoutPreference("desktop")}
        >
          Desktop site
        </button>
      </div>

      <MobileFreqStrip />
    </header>
  );
}
